import { makeStyles } from '@material-ui/core';
import lexipolLogoWhite from './LexipolLogoWhite.svg';

const useStyles = makeStyles({
  logo: {
    width: 150,
    height: 30,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.logo} src={lexipolLogoWhite} alt="Lexipol" />;
};

export default LogoFull;
